/**
 * Copy script
 *
 * Allows users to copy text to the clipboard
 */
// add copy to all dynamically created .copy selectors
document.querySelectorAll('.dynamic-copy-container')?.forEach((wrap) => {
	wrap.addEventListener('click', (e) => {
		if (e.target.classList.contains('copy')) {
			const copy = e.target;
			navigator.clipboard.writeText(copy.dataset.copy).then(
				() => alert(`${copy.dataset.copy} copied`),
				(err) =>
					alert(
						'Error: unable to copy. Please select the text with your mouse and copy using the right mouse button.'
					)
			);
		}
	});
});
